import { Component, OnInit, OnDestroy, ViewChild, ElementRef }  from '@angular/core';
import { Router, ROUTER_DIRECTIVES, ActivatedRoute } from '@angular/router';
import { UserSession } from '../shared/user-session';
import { UserInfoService } from '../shared/user-info.service';
import { IScenario, ScenarioService } from '../scenario-activities/scenario.service';



@Component({
    //templateUrl: 'app/system-management/system-management.component.html',
    template: require('./system-management.component.html'),
    styles: [require('../styles/faa_styles.css')],
    directives: [ROUTER_DIRECTIVES ],
})

export class SystemManagementComponent implements OnInit{
    pageTitle: string = 'System Management';
    errorMessage: string;
    currentScenario: IScenario;
    allScenarios: IScenario[];
    scenarioHeaderDiv: HTMLDivElement;
    isScenarioOwner: boolean = false;

    constructor(private route: ActivatedRoute,
                private router: Router,
                private _scenarioService: ScenarioService,
                private User: UserSession,
                private _userInfoService: UserInfoService ) {
    }
    @ViewChild('scenarioHeader') scenarioHeader: ElementRef;

    ngOnInit(): void{

        this.scenarioHeaderDiv = this.scenarioHeader.nativeElement;
        this._scenarioService.getScenarios(this.User.getSession()['id'])
            .subscribe(
                scenarios => this.allScenarios = scenarios,
                error => this.errorMessage = <any>error,
                () => {
                    this.setScenarioHeader(this.User.getSession().scenarioId);
                }
            );
        
        //this probably needs to be somewhere more central
        this.User.updateSessionState();
        
        this._userInfoService.isScenarioOwner(this.User.getSession()['id'], this.User.getSession().scenarioId).subscribe(
            success => this.isScenarioOwner = success.isOwner,
            error => this.errorMessage = <any>error
        );

    }
    private setScenarioHeader(scenarioId: number):void {
        let foundScenarios:IScenario[] = this.allScenarios.filter(function(scenario){
            return scenario.id === scenarioId;
        });
        if(foundScenarios.length > 0){
            this.currentScenario = foundScenarios[0];
        }
        this.scenarioHeaderDiv.innerHTML = `<strong>Current Scenario: ${this.currentScenario.scenarioName} (${this.currentScenario.id})</strong>`;
    }
}


/** WEBPACK FOOTER **
 ** ./app/system-management/system-management.component.ts
 **/